import React, {useContext, useEffect, useRef, useState} from 'react';
import {AppContext} from "../../../../context/AppContext";
import styles from "../Filter/Filter.module.scss";
import Button from "../../../elements/Button/Button";
import Icon from "../../../elements/Icon/Icon";
import clsx from "clsx";

const Sort = ({isDesktop}) => {
    const {filters, changeFilter} = useContext(AppContext);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const ref = useRef();

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsFilterOpen(false);
            }
        };

        isFilterOpen &&
        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isFilterOpen]);

    const toggleFilterList = () => {
        setIsFilterOpen(!isFilterOpen);
    };

    return (
        <div className={styles.filter} ref={ref}>
            <Button className={styles.filterButton} onClick={toggleFilterList}>
                Sort {isDesktop && 'by date'}
                <Icon
                    name="arrow-down"
                    size={11}
                    color={'var(--color-teal)'}
                    customStyle={{
                        transition: 'transform 350ms ease-in-out',
                    }}
                />
            </Button>
            {isFilterOpen && (
                <ul className={styles.list}>
                    {['newest', 'oldest'].map((option) => (
                        <li key={option}>
                            <Button
                                className={clsx(styles.statusFilter, {
                                    [styles.active]: filters.order === option,
                                })}
                                onClick={() => changeFilter('order', filters.order === option ? 'all' : option)}
                            >
                                {option.charAt(0).toUpperCase() + option.slice(1)}
                            </Button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Sort;
